<template>
  <li v-if="newsItem">
    <a :href="newsItem.url" target="_blank"><h4>{{newsItem.title}}</h4></a>
    <p>{{newsItem.description}}</p>
    <p class="published-at">{{new Date(newsItem.publishedAt).toLocaleString()}}</p>
  </li>
</template>

<script>
export default {
  props: {
    newsItem: Object
  }
};
</script>

<style scoped>
li {
  margin-block: 1rem;
  list-style: auto;
}
.published-at {
  color: rgb(var(--text-primary) / 0.5);
  font-weight: var(--font-weight-regular);
}
</style>